// Keep the address encoded in shipped sources; decode it only in the browser.
export const encodedContactEmail = 'Y29udGFjdEBjZG8tYXBwcy5jb20=';

export function getContactEmail() {
  return atob(encodedContactEmail);
}
